export enum Constraint {
    WORKING_HOURS,
    TIME_WINDOWS,
    SKILLS,
    CAPACITY,
    EVEN_DISTRIBUTION,
}